var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"z-index":"0","position":"fixed","right":"0","bottom":"0","border":"1px solid #ccc"},style:({'left': _vm.left, 'top': _vm.top}),attrs:{"id":"olMapDiv"}})}
var staticRenderFns = []

export { render, staticRenderFns }